// New Component (the Components lists' (+) → "New Component" sheet) — its pure rules
// (component editor, 2026-10-07; Aaron: "need to be able to add new components / copy and
// review from legacy").
//
// Legacy (intent): Add Item's transaction type 0, "Create Maintenance Component"
// (mod_parts/includes/parts_additem.inc). The API side is POST /v6/items with
// `component: true` (Aeronet.app app/items/components.py): status 16, quantity 1, no batch,
// a duplicate serial refused (409), the "Flying" / "Add" history row and the part's
// limitations copied in. After the save legacy opens the new item's record
// (parts_additem.inc:402, form.mode = edit_item); so does this.
import { componentRecordOrigin, componentRecordUrl } from "../items/componentRecord";

export interface ComponentCreateValues {
  part: { number?: string | null } | "" | null | undefined;
  condition: string;
  location: string;
  store: string;
  serial_number: string;
  description: string;
}

/** The POST /v6/items body for a component. Status, quantity and batch are the API's to set. */
export function componentCreatePayload(values: ComponentCreateValues): Record<string, unknown> {
  const part = values.part && typeof values.part === "object" ? values.part : null;
  return {
    component: true,
    part: { number: part?.number ?? "" },
    condition: values.condition,
    location: values.location,
    store: values.store,
    serial_number: values.serial_number.trim(),
    description: values.description,
  };
}

/** The part a selected row stands for: a part row is the part; an item row (Components /
 * Parts with an item filter, or a status list) is its part — never the item's own id, which
 * the sheet used to fetch as a part id. */
export function partRefOfRow(row: any): { id: number } | null {
  if (!row) return null;
  if (row.part && typeof row.part === "object" && row.part.id) return { id: Number(row.part.id) };
  if (row.serial_number !== undefined || row.sn !== undefined) return null; // an item with no part
  return row.id ? { id: Number(row.id) } : null;
}

/** The new component's record, returning to the list the sheet was opened from. */
export function createdComponentUrl(id: number | string, pathname: string): string {
  const mode = pathname.split("/").filter(Boolean).pop() ?? "";
  return componentRecordUrl(id, componentRecordOrigin(new URLSearchParams(`from=${mode}`)));
}
